/* The app's name, in one place. Every screen, and the page titles in
   index.html and preview.html (filled in by vite.config.js), read it from
   here. Leadership may rename the app; until Heidi confirms, it stays as is. */
export const APP_NAME = "CommandTrackHQ";
